import React from 'react';

interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  className?: string;
}

const Dialog: React.FC<DialogProps> = ({ isOpen, onClose, title, children, className = '' }) => {
  if (!isOpen) return null;

  return (
    <div className="mj-dialog-overlay" onClick={onClose}>
      <div className={`mj-dialog ${className}`} onClick={(e) => e.stopPropagation()}>
        <div className="mj-dialog-header">
          <h3 className="mj-dialog-title">{title}</h3>
          <button className="mj-dialog-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="mj-dialog-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Dialog; 